<template>
  <b-card
    title="Angebote"
    style="overflow-x: scroll"
  >
    <div>
      <b-table-simple
        hover
        outlined
        caption-top
        responsive="true"
        striped
        class="rounded-bottom mb-0"
        @row-clicked="onRowClicked"
      >
        <b-thead head-variant="light">
          <b-tr>
            <b-th>Nr</b-th>
            <b-th>Datum</b-th>
            <b-th>Status</b-th>
            <b-th>Lager</b-th>
            <b-th>Gesamtpreis</b-th>
            <b-th>Aktionen</b-th>
          </b-tr>
        </b-thead>
        <b-tbody
          v-for="(offer, index) in offers"
          :key="index"
        >
          <b-tr>
            <b-td>{{ offer.id }}</b-td>
            <b-td>{{ getFormattedDate(offer.created_at) }}</b-td>
            <b-td>
              <b-badge
                :variant="getOfferStatusVariant(offer)"
                class="status-badge"
              >
                {{ getOfferStatusLabel(offer) }}
              </b-badge>
            </b-td>
            <b-td>{{ offer.storages ? offer.storages.length : 0 }} Lager</b-td>
            <b-td>
              <b-badge variant="success">
                {{ getTotalOfferPrice(offer) }}€
              </b-badge>
            </b-td>
            <b-td class="text-center">
              <b-button
                variant="primary"
                size="sm"
                @click="viewOffer(offer)"
              >
                <feather-icon
                  icon="EyeIcon"
                  size="16"
                />
                Anzeigen
              </b-button>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>
  </b-card>
</template>

<script>
import {
  BTableSimple,
  BThead,
  BTr,
  BTh,
  BTd,
  BTbody,
  BCard,
  BBadge,
  BButton,
} from 'bootstrap-vue'
import helper from '@/helper/helper'

export default {
  components: {
    BTableSimple,
    BThead,
    BTr,
    BTh,
    BTd,
    BTbody,
    BCard,
    BBadge,
    BButton,
  },
  setup() {
    const { getFormattedDate } = helper()

    return {
      getFormattedDate,
    }
  },
  computed: {
    offers() {
      const customerId = Number(this.$route.params.id)
      const customerOffers = this.$store.getters.offersByCustomerId(customerId)
      return customerOffers ? customerOffers.sort((a, b) => b.id - a.id) : []
    },
  },
  methods: {
    getTotalOfferPrice(offer) {
      if (!offer.storages) return 0
      return offer.storages.reduce((total, storage) => total + (storage.price || 0), 0)
    },

    getOfferStatusLabel(offer) {
      if (!offer.isActive) {
        return 'Inaktiv'
      }
      if (offer.bookingCompleted) {
        return 'Gebucht'
      }
      return 'Aktiv'
    },

    getOfferStatusVariant(offer) {
      if (!offer.isActive) {
        return 'secondary'
      }
      if (offer.bookingCompleted) {
        return 'success'
      }
      return 'info'
    },

    onRowClicked(offer) {
      this.viewOffer(offer)
    },

    viewOffer(offer) {
      this.$router.push(`/offers-view/${offer.id}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.status-badge {
  font-size: 0.75rem;
  padding: 0.375rem 0.75rem;
  border-radius: 12px;
  font-weight: 500;
}

::v-deep .table {
  td, th {
    border-top: 1px solid #f1f3f4;
    vertical-align: middle;
  }

  thead th {
    border-bottom: 2px solid #dee2e6;
    background: #f8f9fa;
    font-weight: 600;
    color: #495057;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 0.875rem;
  }

  tbody tr:hover {
    background-color: #f8f9fa;
    cursor: pointer;
  }
}
</style>
